import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { usePaymentsContext, useSendMoneyContext } from "@zenith/context";
import { DASHBOARD } from "@zenith/routes/paths";

/**
 * Ends the flow in progress and opens the dashboard once the merchant switches
 * outlet: a checkout or transfer started in one outlet must not carry on in
 * another, and the dashboard shows the new outlet's figures.
 */
export const useGoHomeAfterSwitch = () => {
  const navigate = useNavigate();
  const { clearPaymentsContext } = usePaymentsContext();
  const { clearSendMoneyContext } = useSendMoneyContext();

  return useCallback(() => {
    clearPaymentsContext();
    clearSendMoneyContext();
    navigate(DASHBOARD, { replace: true });
  }, [clearPaymentsContext, clearSendMoneyContext, navigate]);
};
